import vbox from "./vbox"
import vboxDesigner from "./designer/vbox-designer"
import vboxEditor from "./designer/vbox-editor"

import hbox from "./hbox"
import hboxDesigner from './designer/hbox-designer'
import hboxEditor from './designer/hbox-editor'

import itemWrapper from "./item-wrapper"
import itemWrapperDesigner from './designer/item-wrapper-designer'
import itemWrapperEditor from './designer/item-wrapper-editor'

import compWrapper from "./comp-wrapper"

import designerManager from './designer/manager'
import layoutRenderer from './layout-renderer'
import Vue from 'vue'

[designerManager,
  layoutRenderer,
  vbox,vboxDesigner,vboxEditor,
  hbox,hboxDesigner,hboxEditor,
  itemWrapper,itemWrapperDesigner,itemWrapperEditor,
  compWrapper
].forEach(component => {
  Vue.component(component.name, component);
});






// WEBPACK FOOTER //
// ./src/common/components/extend/layout/index.js